export const resetTokenStorageKey = "password-reset-token";

function isStorageUnavailable(error) {
  return (
    error instanceof DOMException &&
    ["SecurityError", "QuotaExceededError"].includes(error.name)
  );
}

export function getStoredPasswordResetToken() {
  try {
    return (
      window.sessionStorage.getItem(resetTokenStorageKey) ||
      getPasswordResetTokenFromUrl()
    );
  } catch (error) {
    if (isStorageUnavailable(error)) {
      return getPasswordResetTokenFromUrl();
    }
    throw error;
  }
}

function getPasswordResetTokenFromUrl() {
  const queryToken = new URLSearchParams(window.location.search).get("token");
  if (queryToken) {
    return queryToken;
  }

  return new URLSearchParams(window.location.hash.slice(1)).get("token") || "";
}

export function clearPasswordResetToken() {
  try {
    window.sessionStorage.removeItem(resetTokenStorageKey);
  } catch (error) {
    if (!isStorageUnavailable(error)) {
      throw error;
    }
  }

  const search = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.slice(1));
  search.delete("token");
  hash.delete("token");
  if (search.toString() !== window.location.search.slice(1) || window.location.hash) {
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${search.size ? `?${search}` : ""}${
        hash.size ? `#${hash}` : ""
      }`,
    );
  }
}

export function capturePasswordResetToken() {
  const token = getPasswordResetTokenFromUrl();

  if (!token) {
    return "";
  }

  try {
    window.sessionStorage.setItem(resetTokenStorageKey, token);
  } catch (error) {
    if (isStorageUnavailable(error)) {
      return token;
    }
    throw error;
  }

  clearPasswordResetTokenFromUrl();
  return token;
}

function clearPasswordResetTokenFromUrl() {
  const search = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.slice(1));
  search.delete("token");
  hash.delete("token");
  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${search.size ? `?${search}` : ""}${
      hash.size ? `#${hash}` : ""
    }`,
  );
}